import {MetadataResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/story_cluster_page/v1/service.types';
import {Head} from '@aboutyou/head-elements';
import {TrackContentPageView} from '@aboutyou/tracking';
import React, {FC} from 'react';
import {
  extractMetaAndLinkTags,
  isSeoData,
  setDataTestIds,
} from '../../../shared-deprecated/metaUtils';
import {useUpdateTargetGroup} from '../../../shared-deprecated/useSelectedTargetGroup';

export const MetaView: FC<MetadataResponse> = ({
  meta,
  recommendedTargetGroup,
}) => {
  const {isTargetGroupUpdating} = useUpdateTargetGroup(recommendedTargetGroup);

  if (!isSeoData(meta)) {
    return null;
  }

  const seoData = meta.type.seoData;
  const [metaTags, linkTags] = setDataTestIds(
    extractMetaAndLinkTags(seoData.elements),
  );

  return (
    <>
      {!isTargetGroupUpdating && (
        <TrackContentPageView pageTitle={seoData.title} />
      )}
      <Head meta={metaTags} link={linkTags}>
        <title data-testid="MetaTitle">{seoData.title}</title>
      </Head>
    </>
  );
};
